import ArtistAuctionRecordTile from "./ArtistAuctionRecordTile";

export default ArtistAuctionRecordTile;
